// extracted by mini-css-extract-plugin
export default {"pageContainer":"BuildingPageHeaderError_pageContainer__CpOrk","button":"BuildingPageHeaderError_button__rsLQ2"};